import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button, TextField, Alert, Card, CardContent } from './ds';

const Login = ({ subtitle = 'Inicia sesión en tu cuenta' }) => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    const result = await login(formData);
    if (!result.success) {
      setError(result.message || result.error || 'Error al iniciar sesión');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <CardContent>
          <div className="login-header">
            <h2>TMC Recipe Manager</h2>
            <p>{subtitle}</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error ? (
              <Alert tone="error" className="login-form__alert">
                {error}
              </Alert>
            ) : null}

            <TextField
              label="Correo electrónico o usuario"
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isLoading}
              placeholder="Ingresa tu correo o usuario"
            />

            <TextField
              label="Contraseña"
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={isLoading}
              placeholder="Ingresa tu contraseña"
            />

            <Button type="submit" variant="solid" block disabled={isLoading} className="login-btn">
              {isLoading ? 'Iniciando sesión…' : 'Iniciar sesión'}
            </Button>
          </form>

          <div className="login-footer">
            <p>¿No tienes una cuenta? Contacta a tu administrador.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
